import { useRef } from 'react'
import { DHL_API } from '../api'

const setCookie = (name, value, days = 7) => {
  const d = new Date()
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
  const expires = `expires=${d.toUTCString()}`
  document.cookie = `${name}=${value};${expires};path=/;Secure;SameSite=Strict`
}

const getCookie = (name) => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}

const storeTokenInCookies = (token) => {
  setCookie('token', token)
  window.history.replaceState(
    null,
    window.location.search,
    window.location.search.split('&').slice(0, -1).join('&')
  )
}

const useAuthToken = () => {
  let { current: isMounted } = useRef(false)
  const tokenKeyName = 'token'
  if (!isMounted) {
    const urlParams = new URLSearchParams(window.location.search)
    let token
    if (urlParams.get(tokenKeyName)) {
      token = urlParams.get(tokenKeyName)
      storeTokenInCookies(token)
    }
    // If auth token is not in available in URL then take it from local storage;
    else {
      token = getCookie(tokenKeyName)
    }
    isMounted = true
    DHL_API.defaults.headers.common['Authorization'] = `Bearer ${token}`
  }
}

export default useAuthToken
